import React, {useEffect, useState} from "react";
import {
    availableFobBettingTypes,
    availableFobHippodromes,
    availableFobHippodromesSubject,
    courseColors,
    racesActionSubject,
} from "../../../store/bulletin.store";
import {useForceUpdate} from "../../../services/misc.functions";
import "../fob-betting.css";
import lockIcon from "../../../assets/feather/lock.svg";
import {
    addToFobBetSlip,
    betSlipActionSubject,
    isAddedFob,
    tjkBetSlipOptions,
} from "../../../services/betslip.service";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry";
import {todayResults} from "../../../store/misc.store";
import jokeyIcon from "../../../assets/img/jokey.png";
import iconDownArrow from "../../../assets/feather/chevron-down.svg";
import iconUpArrow from "../../../assets/feather/chevron-up.svg";
import {Link, useParams} from "react-router-dom";
import {isMobile} from "../../../App";
import {bulletinProvider, getPrettyFormatLastSix} from "../../../services/bulletin.service";
import paths from "../../../paths";
import _ from "lodash";
import {modalServiceSubject} from "../../../services/modal.service";

export const RaceCountdown = ({hippodrome, run}: any) => {
    const [countdown, setCountdown] = useState<string>("");

    useEffect(() => {
        const updateCountdown = () => {
            let times: string[] = hippodrome.runs
                .map((run: any) => run.time)
                .filter(Boolean) // null veya undefined değerleri kaldır
                .sort(); // Saatleri sırala

            // Kullanıcının mevcut saatinden önceki saatleri kaldır
            times = times.filter((time) => {
                let [hour, minute] = time.split(":").map(Number);
                let timeDate = new Date();
                timeDate.setHours(hour, minute, 0, 0); // Saat, dakika ve saniyeyi sıfırla
                return timeDate > new Date();
            });

            let nextRunTime = run ? run.time : times[0]; // Sıradaki yarışı al

            if (!nextRunTime) {
                setCountdown("--:--");
                return;
            }

            let [nextHour, nextMinute] = nextRunTime.split(":").map(Number);
            let nextRunTimeDate = new Date();
            nextRunTimeDate.setHours(nextHour, nextMinute, 0, 0); // Saniyeyi sıfırla

            let now = new Date();
            let diff = nextRunTimeDate.getTime() - now.getTime();
            let minutes = Math.floor(diff / 60000);
            let seconds = Math.floor((diff / 1000) % 60);

            // 1 saatten fazla kaldıysa HH:mm formatı kullan, yoksa MM:ss formatı
            let newCountdown = `${Math.floor(minutes / 60)
                .toString()
                .padStart(2, "0")}:${(minutes % 60).toString().padStart(2, "0")}`;
            setCountdown(newCountdown);
        };

        // İlk çalıştır
        updateCountdown();

        // Her dakika güncelle
        const interval = setInterval(updateCountdown, 1000 * 60);

        return () => clearInterval(interval); // Component unmount olduğunda temizle
    }, [hippodrome]);

    return <div>{countdown}</div>;
};

export function FobHeader({hippodrome}: any) {
    const params = useParams();
    const forceUpdate = useForceUpdate();

    return (
        <>
            {isMobile ? (
                <div className={"d-flex justify-content-between flex-column fob-header my-1"}>
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <h5 className={"mb-0 fw-bold"}>{hippodrome.hippodrome}</h5>
                        </div>

                        <div className="fw-light " style={{fontSize: "11px"}}>
                            {tjkBetSlipOptions.bettingType?.name}
                        </div>
                    </div>
                    <div className={"d-flex justify-content-between align-items-center"}>
                        <div className="d-flex flex-column  hippodrome-conditions">
                            <div className="fw-light">Sıcaklık: {hippodrome.weather.temperature}°C</div>
                            <div className="fw-light">Nem: %{hippodrome.weather.humidity}</div>
                        </div>
                        <div className="d-flex align-items-center">
                            <div className="fob-row">
                                <div className={"mx-1"}>
                                    <div>
                                        <Link
                                            to={`/tjk-at-yarisi-bulteni-bahis-yap/${hippodrome.keyword.toLowerCase()}${
                                                hippodrome._id
                                            }/yorumlar`}
                                            className="btn btn-secondary fw-semibold fs-6 "
                                        >
                                            YORUMLAR
                                        </Link>
                                    </div>
                                </div>
                                <div className="mx-1">
                                    <div className={`nowrap ${params.subpage === "yorumlar" ? "active" : ""}`}>
                                        <Link
                                            to={`/tjk-tv-atyarisi-izle-canli-yayin`}
                                            className="btn btn-secondary fw-semibold fs-6 fob-tv-button"
                                        >
                                            <img
                                                alt={"videoIcon"}
                                                src={
                                                    "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTkuNzExIDIwLS41OTUtLjI5OGMtLjA1LS4wMjUtLjA3NS0uMDI1LS4xLS4wNS00LjIxOS0yLjIzMy02LjEzLTQuNTQxLTYuOS01LjczM0MxLjEgMTIuMzgxIDEgMTAuNTQ0IDEgMTAuMzQ2VjEuMjEybC45OTMtLjI0OEM2LjM4Ni0uMDc4IDguOTY3LS4wMjggOS42ODYuMDIxYy43Mi0uMDUgMy4zMDEtLjEgNy42OTQuOTQzbC45OTMuMjQ4djkuMTM0YzAgLjIyMy0uMTI0IDIuMDM1LTEuMTE3IDMuNTk4LS43NyAxLjE5Mi0yLjY4IDMuNS02LjkyNCA1LjczM2wtLjYyLjMyM1pNMS41MjEgMS42MXY4LjcxYzAgLjA3NS4xIDEuODYyIDEuMDQzIDMuMzI2Ljc0NCAxLjE0MiAyLjU4IDMuMzc2IDYuNyA1LjU2LjAyNS4wMjUuMDUuMDI1LjA3NS4wNWwuMzcyLjE3My4zNzMtLjE5OGM0LjE0NC0yLjE4NCA1Ljk4LTQuNDE4IDYuNzI1LTUuNTYuOTQzLTEuNDY0IDEuMDQzLTMuMjUgMS4wNDMtMy4zMjVWMS42MzRsLS41OTYtLjE0OUMxMi45MTMuNDQzIDEwLjM4MS40OTMgOS43MTEuNTQyaC0uMDQ5Yy0uNjctLjA1LTMuMjAyLS4wOTktNy41NDUuOTQzbC0uNTk2LjEyNVoiIGZpbGw9IiMyQTFEMzAiLz48cGF0aCBkPSJNMTAuNzU0IDUuNThjLS4yNDgtLjA1LS4zOTctLjA1LS4zOTctLjA1LjE0OSAwIC4yNzMuMDI2LjM5Ny4wNVoiIGZpbGw9IiMyQTFEMzAiLz48cGF0aCBkPSJNOS43IDEuMTE5Yy42MjgtLjA0NCAyLjg4Mi0uMDg4IDYuNzE4LjgzM2wuODY3LjIydjcuMDczSDkuN2guMDExTDkuNyAxLjExOVoiIGZpbGw9IiNGRjAwMjAiLz48cGF0aCBkPSJNMi45ODIgOWgtLjg2N3YxLjAzN2MwIC4xOTcuMTA4IDEuNzk5Ljk3NSAzLjE4MS42NzIgMS4wNTMgMi4zNCAzLjA5MyA2LjA0NiA1LjA2OGwuNTQyLjI4NVY5SDIuOTgyWiIgZmlsbD0iIzJBMUQzMCIvPjwvc3ZnPg=="
                                                }
                                                width={18}
                                                className={"me-1"}
                                            />
                                            TV
                                        </Link>
                                    </div>
                                </div>
                                <div className="mx-1">
                                    <div className="dropdown">
                                        <button
                                            className="btn btn-secondary fw-semibold fs-6 dropdown-toggle setting-dropdown"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                fill="currentColor"
                                                className="bi bi-gear"
                                                viewBox="0 0 16 16"
                                            >
                                                <path
                                                    d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"/>
                                                <path
                                                    d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"/>
                                            </svg>
                                        </button>
                                        <ul className="dropdown-menu bg-white w-100">
                                            <li className={"w-100"}>
                                                <a
                                                    className="dropdown-item text-start"
                                                    href="#"
                                                    onClick={() => {
                                                        hippodrome.hideFobResult = hippodrome.hideFobResult ? false : true;
                                                        forceUpdate();
                                                    }}
                                                >
                                                    {hippodrome.hideFobResult ? "Sonuçları göster" : "Sonuçları gizle"}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-block mb-0 px-2 py-0 fw-bold ">
                                <div className="d-flex  justify-content-center align-items-center fs-5 next-run">
                                    <span className="fs-6">Sıradaki koşu</span>
                                    <div className={"d-flex justify-content-center align-items-center"}>
                                        <RaceCountdown hippodrome={hippodrome}></RaceCountdown>

                                        <span className="fs-6 ms-1">{"  sonra."}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={"d-flex justify-content-between align-items-center fob-header my-1"}>
                    <div className="d-flex flex-column">
                        <h5 className={"mb-0 fw-bold"}>{hippodrome.hippodrome}</h5>

                        <div className="d-flex justify-content-between align-items-center hippodrome-conditions">
                            <div className="fw-light me-2">Sıcaklık: {hippodrome.weather.temperature}°C</div>
                            <div className="fw-light">Nem: %{hippodrome.weather.humidity}</div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center">
                        <div className="fob-row">
                            <div className={"mx-1"}>
                                <div>
                                    <Link
                                        to={`/tjk-at-yarisi-bulteni-bahis-yap/${hippodrome.keyword.toLowerCase()}${
                                            hippodrome._id
                                        }/yorumlar`}
                                        className="btn btn-secondary fw-semibold fs-6 "
                                    >
                                        YORUMLAR
                                    </Link>
                                </div>
                            </div>
                            <div className="mx-1">
                                <div className={`nowrap ${params.subpage === "yorumlar" ? "active" : ""}`}>
                                    <Link to={`/tjk-tv-atyarisi-izle-canli-yayin`}
                                          className="btn btn-secondary fw-semibold fs-6 ">
                                        <img
                                            alt={"videoIcon"}
                                            src={
                                                "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTkuNzExIDIwLS41OTUtLjI5OGMtLjA1LS4wMjUtLjA3NS0uMDI1LS4xLS4wNS00LjIxOS0yLjIzMy02LjEzLTQuNTQxLTYuOS01LjczM0MxLjEgMTIuMzgxIDEgMTAuNTQ0IDEgMTAuMzQ2VjEuMjEybC45OTMtLjI0OEM2LjM4Ni0uMDc4IDguOTY3LS4wMjggOS42ODYuMDIxYy43Mi0uMDUgMy4zMDEtLjEgNy42OTQuOTQzbC45OTMuMjQ4djkuMTM0YzAgLjIyMy0uMTI0IDIuMDM1LTEuMTE3IDMuNTk4LS43NyAxLjE5Mi0yLjY4IDMuNS02LjkyNCA1LjczM2wtLjYyLjMyM1pNMS41MjEgMS42MXY4LjcxYzAgLjA3NS4xIDEuODYyIDEuMDQzIDMuMzI2Ljc0NCAxLjE0MiAyLjU4IDMuMzc2IDYuNyA1LjU2LjAyNS4wMjUuMDUuMDI1LjA3NS4wNWwuMzcyLjE3My4zNzMtLjE5OGM0LjE0NC0yLjE4NCA1Ljk4LTQuNDE4IDYuNzI1LTUuNTYuOTQzLTEuNDY0IDEuMDQzLTMuMjUgMS4wNDMtMy4zMjVWMS42MzRsLS41OTYtLjE0OUMxMi45MTMuNDQzIDEwLjM4MS40OTMgOS43MTEuNTQyaC0uMDQ5Yy0uNjctLjA1LTMuMjAyLS4wOTktNy41NDUuOTQzbC0uNTk2LjEyNVoiIGZpbGw9IiMyQTFEMzAiLz48cGF0aCBkPSJNMTAuNzU0IDUuNThjLS4yNDgtLjA1LS4zOTctLjA1LS4zOTctLjA1LjE0OSAwIC4yNzMuMDI2LjM5Ny4wNVoiIGZpbGw9IiMyQTFEMzAiLz48cGF0aCBkPSJNOS43IDEuMTE5Yy42MjgtLjA0NCAyLjg4Mi0uMDg4IDYuNzE4LjgzM2wuODY3LjIydjcuMDczSDkuN2guMDExTDkuNyAxLjExOVoiIGZpbGw9IiNGRjAwMjAiLz48cGF0aCBkPSJNMi45ODIgOWgtLjg2N3YxLjAzN2MwIC4xOTcuMTA4IDEuNzk5Ljk3NSAzLjE4MS42NzIgMS4wNTMgMi4zNCAzLjA5MyA2LjA0NiA1LjA2OGwuNTQyLjI4NVY5SDIuOTgyWiIgZmlsbD0iIzJBMUQzMCIvPjwvc3ZnPg=="
                                            }
                                            width={18}
                                            className={"me-1"}
                                        />
                                        TV
                                    </Link>
                                </div>
                            </div>
                            <div className="mx-1">
                                <div className="dropdown">
                                    <button
                                        className="btn btn-secondary fw-semibold fs-6 dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-gear"
                                            viewBox="0 0 16 16"
                                        >
                                            <path
                                                d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"/>
                                            <path
                                                d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"/>
                                        </svg>
                                    </button>
                                    <ul className="dropdown-menu bg-white w-100">
                                        <li className={"w-100"}>
                                            <a
                                                className="dropdown-item text-start"
                                                href="#"
                                                onClick={() => {
                                                    hippodrome.hideFobResult = hippodrome.hideFobResult ? false : true;
                                                    forceUpdate();
                                                }}
                                            >
                                                {hippodrome.hideFobResult ? "Sonuçları göster" : "Sonuçları gizle"}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-block mb-0 px-2 py-0 fw-bold ">
                            <div className="fw-light d-flex justify-content-between">
                                {tjkBetSlipOptions.bettingType?.name}
                                {tjkBetSlipOptions.bettingType?.id == 1882 &&   <div
                                    className={"d-flex justify-content-start align-items-center"}
                                     onClick={() => {
                                       modalServiceSubject.next({
                                         case: "info",
                                         title: "Ganyan - Kapanış Oranı",
                                         content:
                                           "Kapanış Oranı Oyunu son sabit orana göre oynanır.",
                                         confirm: {
                                           cancel: {
                                             label: "Tamam",
                                             class: "btn-warning fw-semibold w-100",
                                           },
                                         },
                                       });
                                     }}
                                >

                                <i style={{border:"1.3px solid #FFFFFF"}} className="info-circle float-end cursor-pointer">i</i>
                                </div>}
                            </div>

                            <div className="d-flex  justify-content-center align-items-center fs-5 next-run">
                                <span className="fs-6">Sıradaki koşu&nbsp;</span>
                                <div className={"d-flex justify-content-center align-items-center"}>
                                    {/*<img*/}
                                    {/*    src={clockAnimation}*/}
                                    {/*    style={{width: "30px", height: "30px"}}*/}
                                    {/*    alt=""*/}
                                    {/*/>*/}
                                    <RaceCountdown hippodrome={hippodrome}></RaceCountdown>

                                    <span className="fs-6 ms-1">{"  sonra."}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export function OddButton({run, horse, forceUpdate, hippodrome}: any) {
    let horseIsAdded: any = isAddedFob(1, run, horse, hippodrome) !== false ? "selected" : "";

    // let isKOExist = hippodrome.wager_details.find((el: any) => el.type.toString() === '1882');
    return (
        <div
            onClick={() => {
                console.log(run.event_odds[Number(horse.no)])
                if (
                    run.event_odds &&
                    run.event_odds[Number(horse.no)]?.show &&
                    run.event_odds[Number(horse.no)]?.win_odds &&
                    run.event_odds[Number(horse.no)]?.win_odds > 1
                ) {
                    if (tjkBetSlipOptions.bettingType.id !== 1881) {
                        var fobBet = availableFobBettingTypes.find((b: any) => b.id === 1881)
                        if (fobBet) {
                            bulletinProvider.selectFobBettingType(hippodrome, fobBet.id);
                            tjkBetSlipOptions.bettingSubType = {id: run.no.toString(), label: `${run.no}. Koşu`}
                            bulletinProvider.selectBettingColumn(1);
                        }
                    }
                    tjkBetSlipOptions.hippodrome = hippodrome;
                    bulletinProvider.getAvailableFobBettingTypes(hippodrome);
                    let isExistFob = availableFobBettingTypes.find((b: any) => b.id === 1881);

                    if (isExistFob) {
                        if (hippodrome === "all") {
                            bulletinProvider.selectFobBettingType(tjkBetSlipOptions.hippodrome, isExistFob.id);
                            tjkBetSlipOptions.bettingSubType = {id: run.no.toString(), label: `${run.no}. Koşu`}
                        } else {
                            bulletinProvider.selectFobBettingType(hippodrome, isExistFob.id);
                            tjkBetSlipOptions.bettingSubType = {id: run.no.toString(), label: `${run.no}. Koşu`}
                        }
                    } else {
                        if (availableFobBettingTypes.length > 0) {
                            bulletinProvider.selectFobBettingType(hippodrome, availableFobBettingTypes[0].id);
                            tjkBetSlipOptions.bettingSubType = {id: run.no.toString(), label: `${run.no}. Koşu`}
                        }
                    }
                    betSlipActionSubject.next(true);
                    addToFobBetSlip(hippodrome, run, horse, "toggle");
                } else if (run.event_odds[Number(horse.no)]?.status === 'z' || run.event_odds[Number(horse.no)]?.status === 'o') {

                    tjkBetSlipOptions.hippodrome = hippodrome;

                    if (tjkBetSlipOptions.bettingType?.id !== 1882) {
                        var kOBet = availableFobBettingTypes.find((b: any) => b.id === 1882)

                        if (kOBet) {
                            bulletinProvider.selectFobBettingType(hippodrome, kOBet.id);
                            bulletinProvider.selectBettingColumn(1);
                            tjkBetSlipOptions.bettingSubType = {id: run.no.toString(), label: `${run.no}. Koşu`}
                            betSlipActionSubject.next(true);
                            console.log('HERE');
                            addToFobBetSlip(hippodrome, run, horse, "toggle");
                        }
                    } else {
                        betSlipActionSubject.next(true);
                        addToFobBetSlip(hippodrome, run, horse, "toggle");
                    }
                }
            }}
            className={`odd-button ${horseIsAdded} ${run.event_odds[Number(horse.no)]?.isUpdated}`}
            style={{cursor: "pointer"}}>
            {run.event_odds &&
            run.event_odds[Number(horse.no)]?.show &&
            run.event_odds[Number(horse.no)]?.win_odds &&
            run.event_odds[Number(horse.no)]?.win_odds > 1 ? (
                run.event_odds[Number(horse.no)]?.win_odds
            ) : (
                <>
                    {run.event_odds[Number(horse.no)]?.status === 'z'  || run.event_odds[Number(horse.no)]?.status === 'o' ? 'KO' :
                        <img width={18} src={lockIcon}/>
                    }
                </>

            )}
        </div>
    );
}

export function FobBody({hippodrome, index}: any) {
    const forceUpdate = useForceUpdate();
    var sort: any;

    return (
        <React.Fragment key={`dailyruns-i-${index}`}>
            <ResponsiveMasonry key={hippodrome._id} columnsCountBreakPoints={{350: 1, 750: 2, 900: 4}}>
                <Masonry key={hippodrome._id}>
                    {hippodrome.runs.map((run: any, index: any) => {
                        if (run.closeBody === undefined && run.fob_wager_status) {
                            run.closeBody = true;
                        }
                        if (todayResults[hippodrome.keyword] && todayResults[hippodrome.keyword].runsMap![run.no]) {
                            if (hippodrome.hideFobResult !== true) {
                                return (
                                    <div className="card run-card"
                                         key={"fob-list-run" + run.no + hippodrome.keyword + index}>
                                        <div className="card-body">
                                            <div className={"d-flex justify-content-between align-items-center p-1"}>
                                                <h5 className="card-title">{run.no}. Koşu</h5>
                                                <div className="d-flex align-items-center">
                                                    <p
                                                        style={{
                                                            borderRadius: "10px",
                                                            border: "1px solid",
                                                            padding: "0.25rem",
                                                            background: "rgb(239, 239, 244)",
                                                            marginRight: "10px",
                                                        }}
                                                        className={"mb-0 fw-bold"}
                                                    >
                                                        {run.time}
                                                    </p>
                                                </div>
                                            </div>

                                            {todayResults[hippodrome.keyword].runsMap![run.no].horses.map((el: any, i: number) => {
                                                if (i === 0 || i === 1 || i === 2) {
                                                    //   console.log(el);
                                                    return (
                                                        <div
                                                            className={"d-flex fob-list-body"}
                                                            //  if el.result is 1 then background color is green else don't change
                                                        >
                                                            <div className={""}>
                                                                <span className={"fw-bold"}>{el.result} - </span>{" "}
                                                                <span
                                                                    style={{
                                                                        color: el.result == 1 ? "rgb(237 28 36)" : "",
                                                                    }}
                                                                >
                                  {el.name}
                                </span>{" "}
                                                                ({el.no})
                                                            </div>
                                                            <div>{el.difference}</div>
                                                        </div>
                                                    );
                                                }
                                            })}
                                        </div>
                                    </div>
                                );
                            }
                        } else {
                            return (
                                <div className="card run-card"
                                     key={"fob-list-run" + run.no + hippodrome.keyword + index}>
                                    <div className="card-body">
                                        <div className={"row align-items-center p-1"}>
                                            <div
                                                onClick={() => {
                                                    run.closeBody = !run.closeBody;
                                                    forceUpdate();
                                                }}
                                                className={`${isMobile ? "col-8" : "col-7"} d-flex flex-column`}
                                            >
                                                <div className={"d-flex align-items-center"}>
                                                    <h5 className="card-title mb-0">{run.no}.Koşu</h5>

                                                    <span className="course mx-1"
                                                          style={{backgroundColor: courseColors[run.course]}}>
                            {run.course}
                          </span>
                                                    <span className={"fw-medium"}>{run?.distance}m</span>
                                                </div>
                                                <div>
                                                    <p className="fw-medium mb-0"
                                                       style={{fontSize: isMobile ? "14px" : "10px"}}>
                                                        {run?.group} {run?.type_detail || ""} {run?.gender || ""} {run?.gender_detail || ""}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className={"col-2 d-flex justify-content-center"}>
                                                {run.closeBody === true && (
                                                    <div className="dropdown dropdown-without-arrow">
                                                        <button
                                                            className={`btn btn-sm btn-outline-primary dropdown-toggle px-1 py-0`}
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="21"
                                                                height="21"
                                                                fill="currentColor"
                                                                viewBox="0 0 16 16"
                                                            >
                                                                <path
                                                                    d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293V2.5zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"/>
                                                            </svg>
                                                        </button>
                                                        <ul className="dropdown-menu bg-white">
                                                            <li>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => {
                                                                        sort = "no";
                                                                        run.horses = _.orderBy(
                                                                            run.horses,
                                                                            [(a: any) => Number(a[sort.toString()])],
                                                                            ["asc"]
                                                                        );
                                                                        forceUpdate();
                                                                    }}
                                                                >
                                                                    No'ya Göre
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <a
                                                                    className="dropdown-item"
                                                                    href="#"
                                                                    onClick={() => {
                                                                        sort = "agf_ratio1";
                                                                        run.horses = _.orderBy(run.horses, ["agf_ratio1"], ["desc"]);
                                                                        forceUpdate();
                                                                    }}
                                                                >
                                                                    AGF'ye Göre
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a
                                                                    className="dropdown-item"
                                                                    href="#"
                                                                    onClick={() => {
                                                                        run.horses = _.orderBy(
                                                                            run.horses,
                                                                            [(a: any) => Number(run.event_odds[Number(a.no)]?.win_odds)],
                                                                            ["asc"]
                                                                        );
                                                                        forceUpdate();
                                                                    }}
                                                                >
                                                                    Oran'a Göre
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => {
                                                                        run.horses = _.orderBy(run.horses, ["start"], ["desc"]);
                                                                        forceUpdate();
                                                                    }}
                                                                >
                                                                    Kulvar'a Göre
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>

                                            <div
                                                onClick={() => {
                                                    run.closeBody = !run.closeBody;
                                                    console.log(run);
                                                    forceUpdate();
                                                }}
                                                className={`${isMobile ? "col-2" : "col-3"} d-flex justify-content-end`}
                                            >
                                                <p
                                                    // style={{
                                                    //   borderRadius: "10px",
                                                    //   border: "1px solid",
                                                    //   padding: "0.25rem",
                                                    //   background: "rgb(239, 239, 244)",
                                                    // }}
                                                    className={"mb-0 fw-bold fs-6"}
                                                >
                                                    {run.time}{" "}
                                                </p>
                                                {run.closeBody ? <img src={iconUpArrow}/> : <img src={iconDownArrow}/>}
                                            </div>
                                        </div>
                                        {/*  <div className={"d-flex justify-content-between align-items-center p-1"}>

                                        <div onClick={() => {
                                            run.closeBody = !run.closeBody;
                                            forceUpdate();
                                        }} className={"d-flex  flex-column"}>
                                            <div className={"d-flex align-items-center"}>
                                                <h5 className="card-title mb-0">{run.no}. Koşu</h5>

                                                <span
                                                    className="course mx-1"
                                                    style={{backgroundColor: courseColors[run.course]}}
                                                >
                          {run.course}
                        </span>
                                                <span className={"fw-medium"}>{run?.distance}m</span>
                                            </div>
                                            <div>
                                                <p className="me-4 fs-7 fw-medium mb-0">
                                                    {run?.group} {run?.type_detail || ""}{" "}
                                                    {run?.gender || ""} {run?.gender_detail || ""}
                                                </p>
                                            </div>
                                        </div>

                                        <div className={""}>
                                            <div className="dropdown dropdown-without-arrow">
                                                <button
                                                    className={`btn btn-sm btn-secondary dropdown-toggle ms-1`}
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >

                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="16"
                                                            height="16"
                                                            fill="currentColor"
                                                            className="me-1"
                                                            viewBox="0 0 16 16"
                                                        >
                                                            <path
                                                                d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293V2.5zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"/>
                                                        </svg>

                                                </button>
                                                <ul className="dropdown-menu bg-white">
                                                    <li>
                                                        <a
                                                            className="dropdown-item"
                                                            href="#"
                                                            onClick={() => {

                                                            }}
                                                        >
                                                            No'ya Göre
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            className="dropdown-item"
                                                            href="#"
                                                            onClick={() => {

                                                            }}
                                                        >
                                                            AGF'ye Göre
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            className="dropdown-item"
                                                            href="#"
                                                            onClick={() => {

                                                            }}
                                                        >
                                                            Ganyan'a Göre
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            className="dropdown-item"
                                                            href="#"
                                                            onClick={() => {

                                                            }}
                                                        >
                                                            Kulvar'a Göre
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div onClick={() => {
                                            run.closeBody = !run.closeBody;
                                            forceUpdate();
                                        }} className={"d-flex"}>
                                            <p
                                                // style={{
                                                //   borderRadius: "10px",
                                                //   border: "1px solid",
                                                //   padding: "0.25rem",
                                                //   background: "rgb(239, 239, 244)",
                                                // }}
                                                className={"mb-0 fw-bold fs-6"}
                                            >
                                                {run.time}{" "}
                                            </p>
                                            {run.closeBody ? (
                                                <img

                                                    src={iconUpArrow}
                                                />
                                            ) : (
                                                <img

                                                    src={iconDownArrow}
                                                />
                                            )}
                                        </div>

                                    </div>*/}

                                        {run.closeBody === true &&
                                            <>
                                                {
                                                    run.horses.map((el: any, i: number) => {
                                                        return (
                                                            <>
                                                                <div
                                                                    style={!el.run_status ? {opacity: 0.4} : {}}
                                                                    className={"d-flex fob-list-body"}
                                                                    key={"fob-list-horse-" + el.no + hippodrome.keyword + i}
                                                                >
                                                                    <div
                                                                        className={"d-flex justify-content-between align-items-center "}>
                                                                        <div
                                                                            style={{
                                                                                paddingRight: "5px",
                                                                                marginRight: "5px",
                                                                                cursor: "pointer",
                                                                            }}
                                                                            onClick={() => {
                                                                                el.closeBody = !el.closeBody;
                                                                                forceUpdate();
                                                                            }}
                                                                            className={el.closeBody ? "d-none" : ""}
                                                                        >
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="20"
                                                                                height="20"
                                                                                fill="currentColor"
                                                                                className="bi bi-caret-down"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path
                                                                                    d="M3.204 5h9.592L8 10.481zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659"/>
                                                                            </svg>
                                                                        </div>
                                                                        <div
                                                                            style={{
                                                                                paddingRight: "5px",
                                                                                marginRight: "5px",
                                                                                cursor: "pointer",
                                                                            }}
                                                                            onClick={() => {
                                                                                el.closeBody = !el.closeBody;
                                                                                forceUpdate();
                                                                            }}
                                                                            className={!el.closeBody ? "d-none" : ""}
                                                                        >
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="20"
                                                                                height="20"
                                                                                fill="currentColor"
                                                                                className="bi bi-caret-up"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path
                                                                                    d="M3.204 11h9.592L8 5.519zm-.753-.659 4.796-5.48a1 1 0 0 1 1.506 0l4.796 5.48c.566.647.106 1.659-.753 1.659H3.204a1 1 0 0 1-.753-1.659"/>
                                                                            </svg>
                                                                        </div>

                                                                        <div className={"me-1"}>
                                                                            <img
                                                                                src={`https://medya-cdn.tjk.org/formaftp/${el.owner.code}.jpg`}
                                                                                onError={({currentTarget}) => {
                                                                                    currentTarget.onerror = null;
                                                                                    currentTarget.src = jokeyIcon;
                                                                                }}
                                                                                width={21}
                                                                                style={{borderRadius: "50%"}}
                                                                                alt={el.jokey.short_name}
                                                                                className="jockey-uniform float-start "
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            className={"d-flex flex-column align-items-start"}>
                                                                            <div>
                                                                                {el.run_status ? (
                                                                                    <>{el.no} - </>
                                                                                ) : (
                                                                                    <span
                                                                                        className="fw-bold text-danger tooltip opacity-100">
                                        K - <div className="tooltip-text">KOŞMAZ</div>
                                      </span>
                                                                                )}
                                                                                <span
                                                                                    className="fw-bold">{el.name}</span>

                                                                                {/* / {el.jokey.name} */}
                                                                            </div>
                                                                            {/*<div>*/}
                                                                            {/*<span*/}
                                                                            {/*    dangerouslySetInnerHTML={{__html: getPrettyFormatLastSix(el.last6)}}></span>*/}
                                                                            {/*</div>*/}
                                                                        </div>
                                                                    </div>
                                                                    <div className={""}>
                                                                        <div className={"d-flex"}>
                                                                            <OddButton
                                                                                run={run}
                                                                                horse={el}
                                                                                forceUpdate={forceUpdate}
                                                                                hippodrome={hippodrome}
                                                                            ></OddButton>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {el.closeBody && (
                                                                    <div className={"d-block"}>
                                                                        <div className={"d-flex"}>
                                                                            <div className="w-50 px-1 horse-info-fob">
                                                                                Son 6:{" "}
                                                                                <span
                                                                                    dangerouslySetInnerHTML={{__html: getPrettyFormatLastSix(el.last6)}}></span>
                                                                            </div>
                                                                            <div
                                                                                className="w-50 px-1 horse-info-fob d-flex justify-content-between">
                                                                                {el.agf_ratio1 && el.agf_ratio1 !== 0 ? (
                                                                                    <div className={""}>
                                                                                        AGF1:{" "}
                                                                                        <span
                                                                                            className={`fw-bold ${el.agf_sort_no1 === 1 ? "text-success" : ""}`}>
                                          %{el.agf_ratio1}
                                        </span>
                                                                                    </div>
                                                                                ) : (
                                                                                    <></>
                                                                                )}

                                                                                {el.agf_ratio2 && el.agf_ratio2 !== 0 ? (
                                                                                    <div className={""}>
                                                                                        AGF2:{" "}
                                                                                        <span
                                                                                            className={`fw-bold ${el.agf_sort_no2 === 1 ? "text-success" : ""}`}>
                                          %{el.agf_ratio2}
                                        </span>
                                                                                    </div>
                                                                                ) : (
                                                                                    <></>
                                                                                )}
                                                                                {el.agf_ratio1 === 0 && el.agf_ratio2 === 0 && (
                                                                                    <div>
                                                                                        AGF: <span
                                                                                        className={"fw-bold"}>-</span>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div className={"d-flex align-items-stretch"}>
                                                                            <div className="w-50 px-1 horse-info-fob">
                                                                                Jokey: <span
                                                                                className="fw-bold ms-2">{el.jokey.short_name}</span>
                                                                            </div>

                                                                            <div className="w-50 px-1 horse-info-fob">
                                                                                Antrenör: <span
                                                                                className="fw-bold ms-2">{el.trainer.name}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className={"d-flex"}>
                                                                            <div
                                                                                className="w-50 px-1  fs-8 horse-info-fob">
                                                                                Anne: <span
                                                                                className="fw-bold ms-2">{el.mother}</span>
                                                                                <br></br> Baba:{" "}
                                                                                <span
                                                                                    className="fw-bold ms-2">{el.father}</span>{" "}
                                                                            </div>
                                                                            <div className="w-50 px-1 horse-info-fob">
                                                                                En İyi Derece: <span
                                                                                className="fw-bold ms-2">{el.best_time}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className={"d-flex"}>
                                                                            <div className="w-50 px-1 horse-info-fob">
                                                                                Start: <span
                                                                                className="fw-bold ms-2">{el.start}</span>
                                                                            </div>
                                                                            <div className="w-50 px-1 horse-info-fob">
                                                                                Kilo: <span
                                                                                className="fw-bold ms-2">{el.weight}KG</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className={"d-flex"}>
                                                                            <div className="w-50 px-1 horse-info-fob">
                                                                                KGS: <span
                                                                                className="fw-bold ms-2">{el.kgs}</span>
                                                                            </div>
                                                                            <div
                                                                                className="w-50 px-1 horse-info-fob d-flex align-items-center">
                                                                                HP: <span
                                                                                className="fw-bold ms-2">{el.handicap}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </>
                                                        );
                                                    })
                                                }
                                                {!run.fob_wager_status &&
                                                    <div className={"d-flex fob-list-body"}>
                                                        <div
                                                            className={"d-flex justify-content-between align-items-center "}>
                                                            <p className="my-1 alert alert-warning p-2 fs-7 fw-bold">
                                                                Kapanış Oranı Oyunu son sabit orana göre oynanır.
                                                            </p>
                                                        </div>

                                                    </div>}
                                            </>
                                        }
                                    </div>
                                </div>
                            );
                        }
                    })}
                </Masonry>
            </ResponsiveMasonry>
        </React.Fragment>
    );
}

export function FobCards(props: any) {
    const forceUpdate = useForceUpdate();
    const hippodrome: any = props.hippodrome;

    useEffect(() => {
        let availableHippodromesSubject_subscription = availableFobHippodromesSubject.subscribe((res: any) => {
            forceUpdate();
        });
        return () => {
            availableHippodromesSubject_subscription.unsubscribe();
        };
    });

    useEffect(() => {
        let racesActionSubject_subscription = racesActionSubject.subscribe((res: any) => {
            if (res && res.action === "update") {
                forceUpdate();
            }
        });
        return () => {
            racesActionSubject_subscription.unsubscribe();
        };
    });

    useEffect(() => {
        if (hippodrome !== "all" && hippodrome) {
            hippodrome.hideFobResult = true;
        }
    }, [hippodrome]);

    if (hippodrome !== "all" && hippodrome) {
        return (
            <div key={"fob-card"} className="mb-3">
                <FobHeader hippodrome={hippodrome}></FobHeader>
                <FobBody hippodrome={hippodrome}></FobBody>
            </div>
        );
    } else {
        return (
            <>
                {availableFobHippodromes.map((el: any, index: any) => {
                    if (el.hideFobResult === undefined) {
                        el.hideFobResult = true;
                    }
                    return (
                        <div key={"fob-card" + index} className="mb-4">
                            <FobHeader hippodrome={el}></FobHeader>
                            <FobBody key={"fob-body-" + index} index={index} hippodrome={el}></FobBody>
                        </div>
                    );
                })}
            </>
        );
    }
}
